"use client"

import styles from "../../../styles/LandingPage/Patients.module.scss"
import StyledText from "../../typography/typography-component"
import skColors from "../../../styles/skColors"
import Button from "../Button/Button"
import { useTranslations } from "next-intl"
import { Routes, useTypedRouter } from "../../data/routes"
import { TrackedActions } from "../../tracking/trackedActions"

const VideoSection = ({}) => {
  const router = useTypedRouter()
  const t = useTranslations("index")

  return (
    <div className={styles.youtubeEmbedContainer}>
      <StyledText variant={"h2"} color={skColors.turquoise[600]}>
        {t("videoSection.title")}
      </StyledText>

      <iframe
        className={styles.youtubeEmbed}
        src="https://www.youtube.com/embed/GUzeRB7q61U?si=zx_GQZJ1Y0hInWDm"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>

      <Button onClick={() => void TrackedActions.goToSelfCheck()} variant={"primary"}>
        {t("videoSection.cta")}
      </Button>
    </div>
  )
}

export default VideoSection
